"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var react_bootstrap_1 = require("react-bootstrap");
exports.noPadding = function (theme) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding:0 !important;\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    "], ["\n        padding:0 !important;\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    "])));
};
var SimpleGrid = /** @class */ (function (_super) {
    __extends(SimpleGrid, _super);
    function SimpleGrid(props) {
        return _super.call(this, props) || this;
    }
    SimpleGrid.prototype.render = function () {
        var _a;
        var _this = this;
        var sizeCol = 12 / this.props.cols;
        var formattedChildArray = [];
        var counter = 0;
        if (this.props.children !== undefined && this.props.children !== null) {
            var colSizeProp_1 = (_a = {}, _a[this.props.colSize] = sizeCol, _a);
            this.props.children.forEach(function (child) { formattedChildArray.push(core_1.jsx(react_bootstrap_1.Col, __assign({ css: exports.noPadding, key: counter++ }, colSizeProp_1), child)); });
        }
        return (core_1.jsx(react_bootstrap_1.Container, { css: function (t) { return _this.props.containerStyle !== undefined ? _this.props.containerStyle(t) : undefined; }, fluid: this.props.fluid },
            core_1.jsx(react_bootstrap_1.Row, null, formattedChildArray)));
    };
    return SimpleGrid;
}(React.Component));
exports["default"] = SimpleGrid;
var templateObject_1;
//# sourceMappingURL=SimpleGrid.js.map